<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/link/enjoy'">
      <ZuiHeader/>
      <SubPageTemplate page-title="精彩体验" :pageNav="false" dynamically-tab :pid="pid" :sort-by="1" :default-tab-id="tabId" :page-size="10" type="experience" @article-click="articleClick"></SubPageTemplate>
      <ZuiFooter/>
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";

export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: this.$cid.shrine.zuiJiaTiYan,
      tabId: ''
    }
  },
  created() {
    this.tabId = this.$route.query.id;
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  methods: {
    articleClick(item) {
      this.$openNewWindow('/new/link/enjoy/info?id=' + item.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/link/enjoy.vue